import * as React from "react";
import {LegacyChipButton, LegacyChipButtonColor} from "./LegacyChipButton";
import {Display} from "../Display";
import {delay} from "@vebox/etui-core";

export interface ExpandableChipButtonProps {
    accentColor?: string;
    disabled?: boolean;
    title?: any;
    icon?: string;
    checked?: boolean;
    onChange?: (value: boolean) => void;
    color?: LegacyChipButtonColor;
    fitTitleFitParent?: boolean;
    borderRadius?: string;
    hideHeader?: boolean;
    incorporateAll?: boolean; // Please choose a better name
}

export interface ExpandableChipButtonState {
    hovered: boolean;
    animate: boolean;
}

export class ExpandableChipButton extends React.Component<ExpandableChipButtonProps, ExpandableChipButtonState> {

    private expandePartRef: HTMLDivElement;

    constructor(props) {
        super(props);
        this.state = {
            hovered: false,
            animate: false,
        };
        delay(10).then(
            () => this.setState({
                ...this.state,
                animate: true,
            })
        );
    }

    public render() {
        return (
            <div
                onMouseEnter={this.onMouseEntered}
                onMouseLeave={this.onMouseLeave}
                className="chip fit-parent"
                style={{
                    whiteSpace: "nowrap",
                    cursor: this.props.disabled ? "not-allowed" : "pointer",
                    backgroundColor: this.props.checked ? this.props.color.background.checked : this.props.color.background.default,
                    color: this.props.checked ? this.props.color.text.checked : this.props.color.text.default,
                    border: "1px solid " + (this.props.checked ? "transparent" : this.props.color.border),
                    borderRadius: this.props.borderRadius ? this.props.borderRadius : 3,
                    padding: "10px",
                    fontWeight: this.props.checked && !this.props.disabled ? 600 : 200,
                    margin: 5,
                    width: "min-content",
                }}
            >
                {
                    /* ACCENT CHECKED INDICATOR
                <div
                    onClick={this.onChipClicked}
                    style={{
                        borderRadius: "100%",
                        background: this.props.accentColor,
                        height: 15,
                        width: 15,
                        marginRight: 5,
                        padding: 3,
                        filter: this.props.checked ? "brightness(0.92)" : null,
                        userSelect: "none",
                    }}
                >
                    <img
                        src={"./images/buttons/icon-apply.png"}
                        style={{
                            width: "inherit",
                            alignSelf: "center",
                            // visibility: this.props.checked && this.state.animate  ? "inherit" : "hidden",
                            filter: this.props.checked ? "brightness(0.2)" : null,
                            animation: "scale-up-center 0.3s cubic-bezier(0.390, 0.575, 0.565, 1.000) both",
                            display: !this.props.disabled && this.props.checked ? "unset" : "none",
                        }}
                    />
                    <img
                        src={this.props.disabled
                            ? "./images/buttons/icon-forbidden.png"
                            : this.props.icon}
                        style={{
                            width: "inherit",
                            alignSelf: "center",
                            // visibility: this.props.checked && this.state.animate  ? "inherit" : "hidden",
                            filter: this.props.checked ? "brightness(0.2)" : null,
                            animation: "scale-up-center 0.3s cubic-bezier(0.390, 0.575, 0.565, 1.000) both",
                            display: !(!this.props.disabled && this.props.checked) ? "unset" : "none",
                        }}
                    />
                </div>*/}
                <div className="chip-content-wrapper">
                    <div
                        onClick={this.onChipClicked}
                        className="content"
                        style={{
                            transform: "unset",
                            left: "unset",
                            top: "unset",
                            verticalAlign: "middle",
                            marginRight: 5,
                        }}
                    >
                        {this.props.title}
                    </div>
                    <div onClick={undefined} style={{fontWeight: 100}}>{this.props.checked ? this.props.children : null}</div>
                </div>
            </div>
        );
    }

    private onMouseEntered = (e) => {
        this.setState({
            hovered: true,
        });
    }

    private onMouseLeave = (e) => {
        this.setState({
            hovered: false,
        });
    }

    private onExpandedClick = (e) => {
        if (e.target === e.currentTarget) {
            if (this.state.hovered) {
                this.setState({
                    hovered: false,
                });
            }
            this.onChipClicked(e);
        }
    }

    private onChipClicked = (e) => {
        this.setState({
            ...this.state,
            animate: false,
        });
        if (!this.props.disabled && this.props.onChange) {
            this.props.onChange(!this.props.checked);
        }
        delay(10).then(
            () => this.setState({
                ...this.state,
                animate: true,
            })
        );
    }
}
